import React, { useState } from 'react';

/**
 * 바운딩 박스 오버레이 컴포넌트
 * 
 * @param {Array} boundingBoxes - 바운딩 박스 배열 [{ text, bbox: [x1, y1, x2, y2], width, height }]
 * @param {number} imageWidth - 이미지 너비
 * @param {number} imageHeight - 이미지 높이
 * @param {boolean} visible - 오버레이 표시 여부
 * @param {string} color - 바운딩 박스 색상 (기본: 파란색)
 */
export default function BoundingBoxOverlay({ 
  boundingBoxes = [], 
  imageWidth, 
  imageHeight, 
  visible = true,
  color = '#339AF0'
}) {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  if (!visible || !boundingBoxes || boundingBoxes.length === 0) {
    return null;
  }

  return (
    <div 
      className="absolute top-0 left-0 pointer-events-none"
      style={{ 
        width: imageWidth, 
        height: imageHeight,
        zIndex: 10
      }}
    >
      {/* 바운딩 박스들 */}
      {boundingBoxes.map((box, index) => {
        const [x1, y1, x2, y2] = box.bbox;
        const isHovered = hoveredIndex === index;
        
        return (
          <div
            key={index}
            className="absolute pointer-events-auto cursor-pointer transition-all duration-150"
            style={{
              left: `${x1}px`,
              top: `${y1}px`,
              width: `${x2 - x1}px`,
              height: `${y2 - y1}px`,
              border: isHovered ? `3px solid ${color}` : `2px solid ${color}`,
              backgroundColor: isHovered ? `${color}20` : `${color}10`,
              boxShadow: isHovered ? `0 0 10px ${color}80` : 'none'
            }}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
            title={box.text}
          >
            {/* 텍스트 라벨 (호버 시에만 표시) */}
            {isHovered && (
              <div
                className="absolute top-0 left-0 px-2 py-1 text-xs font-medium text-white rounded shadow-lg"
                style={{
                  backgroundColor: color,
                  transform: 'translateY(-100%)',
                  maxWidth: '300px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  zIndex: 20
                }}
              >
                {box.text}
              </div>
            )}
          </div>
        );
      })}
      
      {/* 통계 정보 */}
      <div
        className="absolute bottom-2 right-2 px-3 py-2 rounded-lg shadow-lg text-xs font-medium"
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          border: `1px solid ${color}`,
          color: '#0A1037'
        }}
      >
        📦 바운딩 박스: {boundingBoxes.length}개
      </div>
    </div>
  );
}

